import React from "react";
const PrivacyPolicyContent: React.FC = () => {
  return (
    <>
      <p>
        このお問合せで取得する個人情報の取り扱いは下記3項の利用目的のためであり、この目的の範囲を超えて利用することはございません。
      </p>

      <h2>１．組織の名称</h2>
      <p>組織の名称：ウィソフト株式会社</p>

      <h2>2．個人情報を関する管理者の氏名、所属及び連絡先</h2>
      <p>管理者名：個人情報保護管理者　張　静</p>
      <p>連絡先：044-280-6828</p>

      <h2>3．個人情報の利用目的</h2>
      <ul>
        <li>
          当社の各事業に関するお問い合わせの方の個人情報は、お問い合わせにお答えする及びご要望のあった資料などをお送りするため
        </li>
        <li>
          当社の採用応募の方の個人情報は、採用業務（選考、関連する連絡等）で使用するため
        </li>
      </ul>

      <h2>4．個人情報の第三者提供</h2>
      <p>
        当社は、ご提供いただいた個人情報を次の場合を除き第三者に提供いたしません。
      </p>
      <ul>
        <li>ご本人の同意がある場合</li>
        <li>法令に基づく場合</li>
        <li>
          人の生命、身体又は財産の保護のために必要がある場合であって、人の同意を得ることが困難であるとき
        </li>
        <li>
          公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって本人の、同意を得ることが困難であるとき
        </li>
        <li>
          国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがあるとき
        </li>
      </ul>

      <h2>5．個人情報取扱いの委託</h2>
      <p>
        当社は、事業運営上、お客様により良いサービスを提供するために業務の一部を外部に委託しています。業務委託先に対しては、個人情報を預けることがあります。この場合、個人情報を適切に取り扱っていると認められる委託先を選定し、契約等において個人情報の適正管理・機密保持などによりお客様の個人情報の漏洩防止に必要な事項を取決め、適切な管理を実施させます。
      </p>

      <h2>6．個人情報の開示等の請求</h2>
      <p>
        お客様が当社に対してご自身の個人情報の開示等（利用目的の通知、開示、内容の訂正・追加・削除、利用の停止または消去、第三者への提供の停止、提供記録の開示）に関して、当社「個人情報に関するお問合わせ窓口」に申し出ることができます。その際、当社はご本人を確認させていただいたうえで、合理的な期間内に対応いたします。開示等の申し出の詳細につきましては、下記の「個人情報に関するお問い合わせ窓口」までお問い合わせください。
      </p>

      <p>
        〒210-0022　神奈川県川崎市川崎区池田2丁目6番7号
        <br />
        ウィソフト株式会社　個人情報に関するお問い合わせ窓口
        <br />
        TEL： 044-280-6828
      </p>

      <h2>7．個人情報を提供されることの任意性について</h2>
      <p>
        お客様が当社に個人情報を提供されるかどうかは、お客様の任意によるものです。ただし、必要な項目をいただけない場合、各サービス等が適切な状態で提供できない場合があります。
      </p>

      <h2>
        8．本Webサイトへアクセスしたことを契機として機械的に取得される情報
      </h2>
      <p>
        当社は、閲覧されたWebサイトのセキュリティ確保・ユーザーサービス向上のため、Cookieにより閲覧された方の情報を取得することがあります。
      </p>
    </>
  );
};

export default PrivacyPolicyContent;
